import { Directive, Input, TemplateRef, ViewContainerRef, OnInit } from '@angular/core';
import { AuthService } from '../../../ajs-upgraded-providers';


@Directive({
    selector: "[rlPrivileges]" 
})
export class PrivilegesDirective implements OnInit {

    constructor(private template: TemplateRef<any>, private container: ViewContainerRef, private authService : AuthService){ 
    }

    @Input() rlPrivileges : string[];

    ngOnInit() { 
        if(!this.rlPrivileges || this.rlPrivileges.length == 0){
            return;
        }
        
        this.authService.verifyHasPrivilege(this.rlPrivileges, function() {
            this.container.createEmbeddedView(this.template);
        }.bind(this));
      }
}